import {
    ChangeDetectorRef,
    Component,
    ElementRef,
    EventEmitter,
    Host,
    HostBinding,
    Input,
    OnDestroy,
    Optional,
    Output,
    SkipSelf,
    ViewChild,
} from "@angular/core";
import { ControlContainer } from "@angular/forms";
import { AttributePresenceInput } from "@spscommerce/ng-utils";

import { SpsAbstractFieldsetComponent } from "../forms/sps-abstract-fieldset.abstract.component";
import { SpsTooltipComponent } from "../tooltip/sps-tooltip.component";

@Component({
    selector: "sps-fieldset",
    templateUrl: "./sps-fieldset.component.html"
})
export class SpsFieldsetComponent extends SpsAbstractFieldsetComponent implements OnDestroy {
    static readonly displayName = "sps-fieldset";
    static readonly props = {
        legend: "string",
        optional: "boolean",
        enabled: "boolean",
        toggle: { event: true, type: "boolean" }
    };

    private _stateCheckInterval: number;
    private _aChildHasFocus = false;

    @HostBinding("class.sps-fieldset-container") readonly _spsFieldsetContainerClass = true;

    @Input() legend: string;
    @Input() @AttributePresenceInput() optional: boolean;
    @Input() enabled = true;

    @Output() toggle = new EventEmitter<boolean>();

    @ViewChild(SpsTooltipComponent, { static: false }) tooltip: SpsTooltipComponent;

    get isInErrorState() {
        return this._fieldset ? this._fieldset.status === "INVALID" : false;
    }

    constructor(
        changeDetector: ChangeDetectorRef,
        @Optional()
        @Host()
        @SkipSelf()
        ctrlContainer: ControlContainer,
        elementRef: ElementRef
    ) {
        super(changeDetector, ctrlContainer, elementRef);
        this._stateCheckInterval = <number>window.setInterval(this.checkStateAndShowOrHideTooltip.bind(this), 250);
    }

    ngOnDestroy() {
        clearInterval(this._stateCheckInterval);
    }

    onToggle() {
        if (!this.enabled && this._fieldset) {
            this._fieldset.reset();
        }
        this.toggle.emit(this.enabled);
    }

    checkStateAndShowOrHideTooltip() {
        const aChildHasFocus = this._elementRef.nativeElement.contains(document.activeElement);
        if (this.tooltip) {
            if (this.isInErrorState) {
                if (aChildHasFocus) {
                    this.tooltip.show(true);
                } else if (this._aChildHasFocus) {
                    // A child *had* focus but no longer is that the case
                    this.tooltip.hide();
                }
            } else {
                this.tooltip.hide();
            }
        }
        this._aChildHasFocus = aChildHasFocus;
    }
}

@Component({
    selector: "sps-fieldset-error",
    template: "<ng-content></ng-content>"
})
export class SpsFieldsetErrorComponent {
    static readonly displayName = "sps-fieldset-error";
    static readonly props = {};
}
